/* /about: source carousel, poster-wall and title details, without React. */
(() => {
	const root = document.querySelector('[data-v3][data-yp-page="about"]');
	if (!root) return;
	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
	const compact = window.matchMedia('(max-width: 767px)');
	const condensedWidths = [232, 251, 238, 237, 268, 237, 241, 258, 267, 241];

	// Top10Card switches the actual glyph, fit and silhouette at 768px.
	const updateDigits = () => {
		root.querySelectorAll('[data-yp-card="top10"]').forEach(card => {
			card.dataset.digitType = compact.matches ? 'condensed' : 'wide';
			const digits = card.querySelector('[data-yp-top10-digit]');
			digits.dataset.fit = compact.matches ? 'natural' : 'stretch';
			digits.querySelectorAll('[data-yp-top10-digit-glyph]').forEach(glyph => {
				const url = compact.matches ? glyph.dataset.ypDigitCondensed : glyph.dataset.ypDigitWide;
				glyph.style.maskImage = `url("${url}")`;
				glyph.style.webkitMaskImage = `url("${url}")`;
				if (compact.matches) {
					glyph.style.removeProperty('flex');
					glyph.style.aspectRatio = String(condensedWidths[Number(glyph.dataset.ypDigit)] / 499);
				} else {
					glyph.style.flex = '1';
					glyph.style.removeProperty('aspect-ratio');
				}
			});
		});
	};
	updateDigits();
	compact.addEventListener('change', updateDigits);

	root.querySelectorAll('[data-yp-carousel]').forEach(carousel => {
		const track = carousel.querySelector('[data-yp-carousel-track]');
		const [previous, next] = carousel.querySelectorAll('[data-yp-carousel-controls] button');
		if (!track || !previous || !next) return;
		const recompute = () => {
			const max = track.scrollWidth - track.clientWidth;
			const left = Math.abs(track.scrollLeft);
			previous.disabled = left <= 2;
			next.disabled = max - left <= 2;
		};
		const step = direction => {
			const firstCard = track.firstElementChild;
			if (!firstCard) return;
			const style = getComputedStyle(track);
			const gap = Number.parseFloat(style.columnGap || '0');
			const cardWidth = firstCard.getBoundingClientRect().width + gap;
			const sign = style.direction === 'rtl' ? -1 : 1;
			track.scrollBy({
				left: cardWidth * direction * sign,
				behavior: reduced.matches ? 'auto' : 'smooth',
			});
		};
		previous.addEventListener('click', () => step(-1));
		next.addEventListener('click', () => step(1));
		track.addEventListener('keydown', event => {
			if (event.key === 'ArrowRight') {
				event.preventDefault();
				step(1);
			} else if (event.key === 'ArrowLeft') {
				event.preventDefault();
				step(-1);
			}
		});
		track.addEventListener('scroll', recompute, { passive: true });
		new ResizeObserver(recompute).observe(track);
		recompute();

		let drag = null;
		track.addEventListener('pointerdown', event => {
			if (event.pointerType === 'touch') return;
			if (event.target.closest('a, button, input, [data-no-drag]')) return;
			drag = { startX: event.clientX, startScroll: track.scrollLeft, pointerId: event.pointerId };
			track.setPointerCapture(event.pointerId);
			track.dataset.dragging = '';
		});
		track.addEventListener('pointermove', event => {
			if (!drag || event.pointerId !== drag.pointerId) return;
			track.scrollLeft = drag.startScroll - (event.clientX - drag.startX);
		});
		const endDrag = event => {
			if (!drag || event.pointerId !== drag.pointerId) return;
			if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
			delete track.dataset.dragging;
			drag = null;
		};
		track.addEventListener('pointerup', endDrag);
		track.addEventListener('pointercancel', endDrag);
	});

	let activeDialog = root.querySelector('.v3-title-dialog');
	root.querySelectorAll('[data-yp-about-title]').forEach(button => {
		button.addEventListener('click', () => {
			const template = document.querySelector(`template[data-yp-about-title-template="${button.dataset.ypAboutTitle}"]`);
			if (!template || !activeDialog) return;
			const next = template.content.firstElementChild.cloneNode(true);
			activeDialog.replaceWith(next);
			activeDialog = next;
			next.querySelector('.v3-title-dialog-close button').addEventListener('click', () => next.close());
			next.querySelector('.v3-title-dialog-cta button').addEventListener('click', () => {
				next.close();
				window.setTimeout(() => {
					const trigger = root.querySelector('.about-hero [data-yp-voucher="basic"]');
					if (trigger) {
						trigger.dataset.ypAnalyticsSource = 'rail';
						trigger.click();
						delete trigger.dataset.ypAnalyticsSource;
					}
				}, reduced.matches ? 0 : 300);
			});
			next.addEventListener('mousedown', event => {
				if (event.target === next) next.close();
			});
			next.showModal();
		});
	});

	// Same desktop-only cursor parallax and 0.05 easing as the original.
	const plane = root.querySelector('.about-mosaic');
	if (plane && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced.matches) {
		const target = { x: 0, y: 0 };
		const current = { x: 0, y: 0 };
		let primed = false;
		const tick = () => {
			current.x += (target.x - current.x) * 0.05;
			current.y += (target.y - current.y) * 0.05;
			plane.style.setProperty('--mouse-x', current.x.toFixed(3));
			plane.style.setProperty('--mouse-y', current.y.toFixed(3));
			window.requestAnimationFrame(tick);
		};
		window.addEventListener('mousemove', event => {
			target.x = event.clientX / window.innerWidth - 0.5;
			target.y = event.clientY / window.innerHeight - 0.5;
			if (!primed) {
				primed = true;
				current.x = target.x;
				current.y = target.y;
			}
		}, { passive: true });
		window.requestAnimationFrame(tick);
	}
})();
